export default __webpack_public_path__ + "static/media/rs-descarte.ad8c4963.jpg";